import { render, staticRenderFns } from "./SubmissionWaterReport.vue?vue&type=template&id=182479e5"
import script from "./SubmissionWaterReport.vue?vue&type=script&lang=js"
export * from "./SubmissionWaterReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports